var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.85 8C15.85 11.875 13.0063 15.0938 9.2875 15.6562V10.25H11.1L11.4438 8H9.2875V6.5625C9.2875 5.9375 9.6 5.34375 10.5688 5.34375H11.5375V3.4375C11.5375 3.4375 10.6625 3.28125 9.7875 3.28125C8.0375 3.28125 6.88125 4.375 6.88125 6.3125V8H4.9125V10.25H6.88125V15.6562C3.1625 15.0938 0.35 11.875 0.35 8C0.35 3.71875 3.81875 0.25 8.1 0.25C12.3813 0.25 15.85 3.71875 15.85 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.cf4b1220bf0c387f3f1240ba15524b81.svg";
export { ForwardRef as ReactComponent };